
$(window).on("load resize",(function(){
  if ($(window).width() < 767) {
   // Product gallery
  $('.product__media-list').slick({
		dots: true,
		infinite: true,
		arrows:false,
		speed: 500,
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1
  });
  } else {
    //$('.product__media-list').unslick();
   // $('.product__media-list')[0].slick.unslick();

  }
}));